import {getUserId} from '@Libraries/user.library';
import {openPremiumAgreementModal} from '@Modals/premium-agreement-modal/premium-agreement-modal.library';

const GETTY_LICENSE_NAME = 'getty';

let premiumAgreement = false;
const hasAgreedToPremiumLicense = async (): Promise<boolean> => {
  premiumAgreement = premiumAgreement || !!(await checkIfHasAgreedToLicense());
  return premiumAgreement;
};

const checkIfHasAgreedToLicense = async (): Promise<string> => {
  const cacheKey = getCacheKey();

  try {
    return (await window.PMW.readLocal('user/hasuseragreedto', {license: GETTY_LICENSE_NAME}, cacheKey)) as string;
  } catch {
    return '';
  }
};

const getCacheKey = (): string => {
  const userId = getUserId();
  if (userId === undefined) {
    return '';
  }
  return GETTY_LICENSE_NAME + String(userId);
};

export const addUserGettyAgreement = async (): Promise<void> => {
  await window.PMW.writeLocal('user/adduseragreement', {license: GETTY_LICENSE_NAME});
  window.PMW.deleteCacheItem(getCacheKey());
};

const showPremiumLicenseAgreement = async (): Promise<boolean> => {
  premiumAgreement = await new Promise((resolve) => {
    openPremiumAgreementModal({
      onDecision: resolve,
    });
  });

  return premiumAgreement;
};

export const validateGettyLicenseAgreement = async (onAgreementModalOpen?: () => void): Promise<boolean> => {
  let agreed = await hasAgreedToPremiumLicense();
  if (!agreed) {
    onAgreementModalOpen?.();
    agreed = await showPremiumLicenseAgreement();
  }

  return agreed;
};
